import { ExtraDiscountBannerProps } from '@/components/extraDiscountBanner/types'
import { TextHTML } from '@/components/typography'

export const ExtraDiscountBanner = ({ title, description, iconNode }: ExtraDiscountBannerProps) => {
  return (
    <div className="extra-discount-plan-section" key="extra-discount-plan">
      <div className="extra-discount-container">
        <div className="item">
          <div>
            {iconNode && typeof iconNode === 'object' && 'src' in iconNode ? (
              <img src={iconNode.src} alt="" loading="lazy" />
            ) : (
              iconNode
            )}
          </div>
          <div>
            <TextHTML className="text" title={title} />
            {description && <TextHTML className="description" title={description} />}
          </div>
        </div>
      </div>
    </div>
  )
}
